import { Document } from '@tiptap/extension-document'

export const RequireHeading = Document.extend({
  content: 'heading block*',
})
